import { useState, useEffect } from "react";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import "./App.css";
import {ToastContainer, toast} from 'react-toastify';
import {
  COMMENT,
  CURRENTLINE,
  PURPLE,
  YELLOW,
  FOREGROUND,
} from "./helpers/colors";
import { ContactContext } from "./context/contactContext";
import {
  AddContact,
  Contacts,
  ViewContact,
  Navbar,
  EditContact,
} from "./components";
import {
  getAllContacts,
  getAllGroups,
  createContact,
  deleteContact,
} from "./services/contactService";
import { confirmAlert } from "react-confirm-alert";

const App = () => {
  const [loading, setLoading] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [filteredContacts, setFilteredContacts] = useState([]);
  const [groups, setGroups] = useState([]);
  const [contact, setContact] = useState({});
  const [contactQuery, setContactQuery] = useState({text: ""});

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const { data: contactsData } = await getAllContacts();
        const { data: groupsData } = await getAllGroups();

        setContacts(contactsData);
        setFilteredContacts(contactsData);
        setGroups(groupsData);

        setLoading(false);
      } catch (err) {
        console.log(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const createContactForm = async (values) => {
    try {
      setLoading(true);
      const { status, data } = await createContact(values);

      if (status === 201) {
        toast.success("contact was successfully created")

        const allContacts = [...contacts, data];
        setContacts(allContacts);
        setFilteredContacts(allContacts);

        setLoading((prevLoading) => !prevLoading);
        navigate("/contacts");
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  const onContactChange = (event) => {
    setContact({ ...contact, [event.target.name]: event.target.value });
  };

  const confirmDelete = (contactId, contactFullname) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div
            dir="rtl"
            style={{
              backgroundColor: CURRENTLINE,
              border: `1px solid ${PURPLE}`,
              borderRadius: "1em",
            }}
            className="p-4"
          >
            <h1 style={{ color: YELLOW }} className="text-center">
              {" "}
              Remove contact{" "}
            </h1>
            <p style={{ color: FOREGROUND }} className="text-center">
              ? Are you sure to delete {contactFullname}
            </p>
            <div className="d-flex justify-content-center">
              <button
                onClick={() => {
                  removeContact(contactId);
                  onClose();
                }}
                className="btn mx-2"
                style={{ backgroundColor: PURPLE }}
              >
                I am sure
              </button>
              <button
                onClick={onClose}
                className="btn"
                style={{ backgroundColor: COMMENT }}
              >
                Cancel
              </button>
            </div>
          </div>
        );
      },
    });
  };

  const removeContact = async (contactId) => {

    const allContacts = [...contacts];

    try {
      
      const updatedContacts = contacts.filter(c => c.id !== contactId);
      setContacts(updatedContacts);
      setFilteredContacts(updatedContacts);

      const {status} = await deleteContact(contactId);

      toast.error("contact was successfully deleted")
      if (status !== 200) {

        setContacts(allContacts);
        setFilteredContacts(allContacts);
      }
    } catch (err) {
      console.log(err.message);

      setContacts(allContacts);
      setFilteredContacts(allContacts);
    }
  };

  const contactSearch = (event) => {
    setContactQuery({ ...contactQuery, text: event.target.value });
    const allContacts = contacts.filter((contact) => {
      return contact.fullname
        .toLowerCase()
        .includes(event.target.value.toLowerCase());
    });

    setFilteredContacts(allContacts);
  };

  return (
    <ContactContext.Provider
      value={{
        loading,
        setLoading,
        contact,
        setContacts,
        contactQuery,
        contacts,
        filteredContacts,
        setFilteredContacts,
        groups,
        onContactChange,
        deleteContact: confirmDelete,
        createContact: createContactForm,
        contactSearch,
      }}
    >
      <div className="App">
        <ToastContainer position="top-right" theme="colored" />
        <Navbar />
        <Routes>
          <Route path="/" element={<Navigate to="/contacts" />} />
          <Route path="contacts" element={<Contacts />} />
          <Route path="/contacts/add" element={<AddContact />} />
          <Route path="/contacts/:contactId" element={<ViewContact />} />
          <Route path="/contacts/edit/:contactId" element={<EditContact />} />
        </Routes>
      </div>
    </ContactContext.Provider>
  );
};

export default App;
